<div>
    <input type="text" class="form-control my-2" [(ngModel)]="vaccins"  placeholder="Recherche vaccine">
    <nav class="tree-nav scroll" >

        <div class="flex" *ngFor="let vaccin of values |filterVaccin:vaccins;let i= index">
            <span class="label">{{vaccin.nom_commercial_Vaccin}}</span>
            <input type="checkbox" name="" id=""  class="checkbox" (change)="changed(vaccin,$event,i)"   >
        </div>
        </nav>
        <button class="btn btn-primary ajouter" (click)="close()">Ajouter</button>
</div>
